import React from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Mamadou DIOP",
    role: "Entrepreneur, Almadies",
    rating: 5,
    text: "TPCO a livré notre appartement aux Almadies en respectant les délais et la qualité promise. L'équipe a été à l'écoute du début à la fin. Je recommande vivement.",
    initials: "MD",
    color: "bg-[#1E3A8A]",
  },
  {
    name: "Fatou NDIAYE",
    role: "Médecin, Sicap Liberté",
    rating: 5,
    text: "Achat d'une villa via TPCO Sénégal. Service exemplaire, accompagnement personnalisé, et un suivi après-vente exceptionnel. Notre famille est ravie.",
    initials: "FN",
    color: "bg-[#E91E63]",
  },
  {
    name: "Sonatel SA",
    role: "Direction immobilière",
    rating: 5,
    text: "Partenaire fiable pour nos programmes de logements collaborateurs. Qualité de construction, transparence des coûts et professionnalisme reconnus.",
    initials: "S",
    color: "bg-[#2D7A3F]",
  },
];

export default function Testimonials() {
  return (
    <section className="bg-white py-20 lg:py-24" data-testid="testimonials">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center max-w-3xl mx-auto mb-14"
        >
          <div className="text-[12px] text-[#E91E63] font-bold tracking-[0.3em] mb-3">// TÉMOIGNAGES</div>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-extrabold leading-[1.1] tracking-tight text-[#0F1A3D]" style={{ fontFamily: "'Playfair Display', serif" }}>
            Ce qu'en disent<br />nos clients
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="bg-[#F8FAFC] border border-[#E2E5F1] rounded-xl p-7 hover:shadow-lg transition relative"
              data-testid={`testimonial-${i}`}
            >
              <Quote className="absolute top-5 right-5 w-8 h-8 text-[#E91E63]/15" />
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, k) => (
                  <Star key={k} className="w-3.5 h-3.5 fill-[#FFB400] text-[#FFB400]" />
                ))}
              </div>
              <p className="text-sm text-[#4B5775] leading-relaxed italic">"{t.text}"</p>
              <div className="flex items-center gap-3 mt-6 pt-6 border-t border-[#E2E5F1]">
                <div className={`w-12 h-12 rounded-full ${t.color} text-white flex items-center justify-center font-bold text-sm shrink-0`}>
                  {t.initials}
                </div>
                <div>
                  <div className="font-bold text-sm text-[#0F1A3D]">{t.name}</div>
                  <div className="text-xs text-[#4B5775]">{t.role}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
